import React, { useCallback, useEffect, useState } from "react";
import { Button, Row, Col, Table, Select, Input, Form, Checkbox, notification, AutoComplete, DatePicker, message, Skeleton } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { CiSquarePlus } from "react-icons/ci";
import { ajaxService, awsService, containerService, destinationService, dropdownService, loadingPlanService, shippingLineService } from "../../../services";
import { useNavigate, useParams } from "react-router-dom";
import ImageUploader from "../../../components/ImageUploader";
import { CONTAINERS } from "../../../constants";
import dayjs from "dayjs";
import VehicleDropDown from "../loadingplan/VehicleDropdown";
import { changeDocumentTitle } from "../../../utils/title";
import { debounce } from 'lodash';
import MaterialLikeInput from "../../../components/MaterialLikeInput";
import MaterialLikeSelect from "../../../components/MaterialLikeSelect";
import MaterialLikeDatePicker from "../../../components/MaterialLikeDatePicker";

function validate(value) {
  return value === null || value === "" ? "-" : value;
}

let originalBookingNumber = null;

function EditSavePlan() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const hasUserEdited = React.useRef(false);
  const [loading, setLoading] = useState(false);
  const [carLoading, setCarLoading] = useState(false);
  const [freightLoad, setFreightLoad] = useState(false);
  const [customerOwnLoading, setCustomerOwnLoading] = useState(0);
  const [ledger, setLedger] = useState([]);
  const [loadingPlan, setLoadingPlan] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [newCarOptions, setNewCarOptions] = useState([]);
  const [shippingLine, setShippingLine] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [containerSize, setContainerSize] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });

  const [fileList, setFileList] = useState([]);
  const [removedImages, setRemovedImages] = useState([]);
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState([]);
  const [DG, setIsDG] = useState(false)

  const [type, setType] = useState(null)

  const [bookingLoading, setBookingLoading] = useState(false)
  const [bookingMessage, setBookingMessage] = useState(null)
  const [bookingInput, setBookingInput] = useState("");

  const [bookingExists, setBookingExists] = useState(null)

  const columns = [
    {
      title: "Vehicle",
      dataIndex: "vehicle",
      key: "Vehicle",
    },
    {
      title: "Chassis Number",
      dataIndex: "chasis_no",
      key: "Chassis_Number",
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "Value",
    },
    {
      title: "Weight",
      dataIndex: "weight",
      key: "Weight",
    },
    {
      title: "Engine Type",
      dataIndex: "engine_type",
      key: "Engine_Type",
    },
    {
      // title: " Classes",
      dataIndex: "class",
      key: "class",
      width: 200,
      render: (text, record) => {

        if (record.engine_type === "EV" || record.engine_type === "HYBRID") {
          const isError = !record.shipping_class_id
          return (
            <div>
              <Select
                value={record.shipping_class_id}
                onChange={(value) => handleClassChange(record.id, value)}
                style={{ minWidth: "200px", maxWidth: "200px" }}
                popupMatchSelectWidth={false}
              >
                {classes.map((classItem) => (
                  <Select.Option key={classItem.id} value={classItem.id}>
                    {classItem.class} - {classItem.code}
                  </Select.Option>
                ))}
              </Select>
              {isError && (
                <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                  Please select a class.
                </div>
              )}
            </div>
          )
        } else {
          return (
            <></>
          )
        }
      },
    },
    {
      title: (
        <div>
          <DeleteOutlined style={{ fontSize: "18px" }} />
        </div>
      ),
      key: "Delete",
      render: (text, record, { _id }) => (
        <Button
          type="primary"
          size="small"
          onClick={() => handleDelete(record.id)}
        >
          <DeleteOutlined />
        </Button>
      ),
    },
  ];

  const columns2 = [
    {
      title: "id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Vendor",
      dataIndex: "vendor_id",
      key: "vendor_id",
      width: "300px",
      render: (text, record) => (
        <Select
          value={record.vendor_id}
          onChange={(value) => handleFieldChange(record.id, "vendor_id", value)}
          style={{ width: "100%" }}
        >
          {vendors.map((ven) => (
            <Select.Option key={ven.id} value={ven.id}>
              {ven.name}
            </Select.Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: "300px",
      render: (text, record) => (
        <Input
          value={record.description}
          style={{ width: "100%" }}
          onChange={(e) =>
            handleFieldChange(record.id, "description", e.target.value)
          }
        />
      ),
    },

    {
      title: (
        <div>
          <DeleteOutlined style={{ fontSize: "18px" }} />
        </div>
      ),
      key: "Delete",
      render: (text, record, index) => {
        if (ledger.length === 1) return null;
        return (
          <Button
            type="primary"
            size="small"
            onClick={() => handleDeleteRow(record.id)}
          >
            <DeleteOutlined />
          </Button>
        );
      },
    },
  ];


  const handleChange = (info) => {
    let updatedFileList = [...info.fileList];

    // CHANGES HIGHLIGHTED: Handle removed files
    if (info.file.status === "removed") {
      const removedFile = info.file;

      if (removedFile.url) {
        setRemovedImages((prev) => [...prev, removedFile.url]);
      }
    }

    setFileList(updatedFileList);
  };

  // API call function
  const fetchCarOptions = async (query, setOptions) => {
    if (!query) {
      setOptions([]);
      return;
    }
    try {
      setCarLoading(true)
      const response = await dropdownService.fetchVehiclesOnSearch({ query });
      setCarLoading(false)
      if (response.success) {
        setOptions(
          response.data.map((car) => ({
            value: `${validate(car?.vehicle)} || ${validate(car?.chasis_no)} || ${validate(car?.year)} || ${validate(car?.container_no)} || ${validate(car?.customer_name)}`,
            label: `${validate(car?.vehicle)} || ${validate(car?.chasis_no)} || ${validate(car?.year)} || ${validate(car?.container_no)} || ${validate(car?.customer_name)}`,
            data: car,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching vehicle options:", error);
      setOptions([]);
    }
  };

  const handleSelect = (value, option) => {
    const { data } = option;
    const selectedCar = {
      id: data.id,
      vehicle: data.vehicle,
      chasis_no: data.chasis_no,
      value: data.value,
      weight: data.weight,
      engine_type: data.engine_type,
    };

    setVehicles((prev) => {
      const exists = prev.some((car) => car.chasis_no === selectedCar.chasis_no);
      if (exists) {
        message.error(`The chasis number ${selectedCar.chasis_no} already exists.`)
        return prev;
      }
      return [...prev, selectedCar];
    });

    form.setFieldsValue({ new_car: "", reload_car: "" });
  };

  const handleAddRow = () => {
    setLedger([
      ...ledger,
      {
        id: ledger.length > 0 ? ledger[ledger?.length - 1].id + 1 : 1,
        vendor_id: "",
        description: "",
      },
    ]);
  };

  const handleFieldChange = (id, field, value) => {
    setLedger((prevLedger) =>
      prevLedger.map((entry) =>
        entry.id === id ? { ...entry, [field]: value } : entry
      )
    );
  };

  const handleClassChange = (id, value) => {
    setSelectedClass((prev) => ({
      ...prev,
      [id]: value, // Store selected value per row
    }));
    // Update vehicles state with shipping_class_id
    setVehicles((prevVehicles) => {
      return prevVehicles.map((vehicle) => {
        if (vehicle.id === id && (vehicle.engine_type === "EV" || vehicle.engine_type === "HYBRID")) {
          return {
            ...vehicle,
            shipping_class_id: value, // Add the shipping_class_id key with the selected value
          };
        }
        return vehicle; // Return the vehicle as is if it doesn't match
      });
    });
  };

  // Delete handler
  const handleDelete = (id) => {
    setVehicles((prevData) => prevData.filter((item) => item.id !== id));
  };

  const handleCheckboxChange = (e) => {
    setIsDG(e.target.checked);
  };


  const handleDeleteRow = (id) => {
    setLedger((prevLedger) => prevLedger.filter((entry) => entry.id !== id));
  };

  const onFinish = async (val) => {
    setLoading(true);

    const additionalData = type === "Update - Load" ? { load: "Update - Load" } : type === "Update - Save" ? { save: "Update - Save" } : {};

    const merged = form.getFieldsValue();

    const carid = vehicles.map((car) => car.id);
    const { new_car, reload_car, ...values } = merged;
    const { c_booking_number, container_id, c_container_number, shipping_line_id, is_customer_own_loading, ...newValues } = values;
    const shippingClasses = vehicles
      .filter((vehicle) => vehicle.engine_type === "EV" || vehicle.engine_type === "HYBRID")
      .map((vehicle) => ({
        vehicle_id: vehicle.id, // Use the vehicle's unique id
        shipping_class_id: vehicle.shipping_class_id, // Use the appropriate shipping class
      }));

    const payload = {
      ...newValues,
      load_number: values.container_id,
      location: values?.location ?? loadingPlan.location,
      booking_number: values.c_booking_number,
      container_number: values.c_container_number,
      shipping_line: values.shipping_line_id,
      checksave: loadingPlan?.status,
      ...(customerOwnLoading ? { is_customer_own_loading: "on" } : {}),
      pull_out_date: values?.pull_out_date?.format("YYYY-MM-DD") ?? null,
      customised_date: values?.customised_date?.format("YYYY-MM-DD") ?? null,
      gate_in_date: values?.gate_in_date?.format("YYYY-MM-DD") ?? null,
      eta_date: values?.eta_date?.format("YYYY-MM-DD") ?? null,
      carid,
      ...additionalData,
      ...(DG ? { is_dg: "on" } : {}),
      ...(shippingClasses.length > 0 ? { classes: shippingClasses } : {})
    };

    let images = [];
    if (fileList.length > 0) {

      const newFiles = fileList.filter((file) => file.originFileObj);

      if (newFiles.length > 0) {
        images = await awsService.uploadS3Bucket(newFiles, false, payload.load_number, CONTAINERS);
      }

      const existingImages = fileList
        .filter((file) => file.url && !removedImages.includes(file.url)) // CHANGES HIGHLIGHTED: Exclude removed images
        .map((file) => file.url);

      images = [...images, ...existingImages];

    }
    // CHANGES HIGHLIGHTED: Delete removed images from AWS S3
    if (removedImages.length > 0) {
      await awsService.deleteFromS3Bucket(removedImages);
    }

    const data = { ...payload, images, removedImages };

    const response = await loadingPlanService.updatePlan(id, data);
    setLoading(false);

    if (response?.success ?? false) {
      notification.success({ message: "Successfully updated!", description: response.message, placement: "topRight" });
      setRemovedImages([]);
      initialize();
      navigate(type === "Update - Save" ? `/operations/loadings/save-containers` : `/operations/loadings`);
    }
  };

  const handleFreight = async () => {
    setFreightLoad(true);
    const payload2 = {
      vendor_id: ledger.map((item) => item.vendor_id),
      description: ledger.map((item) => item.description),
    };
    const response = await loadingPlanService.updatePlanFrieght(id, payload2);
    if (response.success) {
      notification.success({
        message: "Successfully updated!",
        description: response.message,
        placement: "topRight",
      });
    }
    setFreightLoad(false);
    navigate(`/operations/loadings/save-containers`)
  };

  const initialize = async (page = 1, pageSize = pagination.current) => {
    const hide = message.loading("Fetching Data...", 0)
    const { success, data } = await loadingPlanService.View(id, page);
    hide();
    if (success) {
      setLoadingPlan(data.container);
      const vehicleList = data.containers.data.map((item) => item.vehicle).filter((vehicle) => vehicle !== null);
      setLedger(data.ledger);
      setVehicles(vehicleList);

      setIsDG(data.container.is_dg)
      setBookingInput(data.container.c_booking_number);
      originalBookingNumber = data.container.c_booking_number

      if (data.container.myimages) {
        const fileList = data.container.myimages.map((image) => ({
          uid: image.id.toString(),
          name: (image.image).substring(image.image.lastIndexOf('/') + 1),
          status: "done",
          url: image.image,
        }));

        setFileList(fileList);
      }

      setPagination((prev) => ({
        ...prev,
        total: data.containers.total,
        current: page,
        pageSize,
      }));

      setCustomerOwnLoading(data.container.is_customer_own_loading);
      form.setFieldsValue({
        ...data.container,
        eta_date: data.container.eta_date ? dayjs(data.container.eta_date).tz() : null,
        customised_date: data.container.customised_date ? dayjs(data.container.customised_date).tz() : null,
        pull_out_date: data.container.pull_out_date ? dayjs(data.container.pull_out_date).tz() : null,
        gate_in_date: data.container.gate_in_date ? dayjs(data.container.gate_in_date).tz() : null,
      });

    }
  };

  const getQuotationVendors = async () => {
    const response = await dropdownService.fetchQuotationVendors();
    if (response.success) {
      setVendors(response.data);
    }
  };

  const getShippingLine = async () => {
    const response = await shippingLineService.fetch();
    if (response.success) {
      setShippingLine(response.data);
    }
  };

  const getDestinations = async () => {
    const response = await destinationService.fetchDestination();
    if (response.success) {
      setDestinations(response.data);
    }
  };
  const getContainerSize = async () => {
    const response = await containerService.fetchsizes();
    if (response.success) {
      setContainerSize(response.data);
    }
  };

  const getClasses = async () => {
    const response = await loadingPlanService.fetchClasses();
    if (response.success) {
      setClasses(response.data)
    }
  }

  const checkBookingExistsDebounced = useCallback(
    debounce(async (value, originalBookingNumber) => {
      if (!value) {
        setBookingMessage('');
        setBookingExists(null);
        return;
      }
      console.log(value, originalBookingNumber);
      if (value === originalBookingNumber) return;

      setBookingLoading(true);
      try {
        const response = await ajaxService.post('/containers/check-booking-number', { booking_number: value });
        if (response?.success) {
          setBookingExists(response.data.exist);
          setBookingMessage(response.message);
        } else {
          setBookingMessage(response?.message || '');
        }
      } catch (err) {
        console.error(err);
        setBookingMessage('Error checking booking number');
      }
      setBookingLoading(false);
    }, 850),
    []
  );

  const SkeletonButton = ({ onClick, children, loading }) => (
    bookingLoading
      ? <Skeleton.Input active style={{ width: 150 }} />
      : <Button type="primary" style={{ width: "100%" }} htmlType="submit" onClick={onClick} loading={loading}>
        {children}
      </Button>
  );

  useEffect(() => {
    const initialBooking = form.getFieldValue("c_booking_number") || "";
    setBookingInput(initialBooking);
  }, [form]);

  useEffect(() => {
    hasUserEdited.current = false;
  }, [originalBookingNumber]);

  useEffect(() => {
    changeDocumentTitle(" Edit Saved Plan");
    getShippingLine();
    getQuotationVendors();
    getDestinations();
    getContainerSize();
    getClasses();
    initialize(pagination.current, pagination.pageSize);
  }, [pagination.current, pagination.pageSize]);

  const RenderTitle = ({ title }) => (
    <>
      {title}<span style={{ color: 'red', fontSize: '12px', marginLeft: 5 }}> (This is required for load only)</span>
    </>
  );

  return (
    <>
      <Row gutter={16}>
        <Col span={5}>
          <div
            style={{
              paddingTop: "8px",
              paddingRight: "8px",
              paddingLeft: 8,
            }}
          >
            <ImageUploader
              fileList={fileList}
              beforeUpload={true}
              handleChange={handleChange}
              setFileList={setFileList}
              setRemovedImages={setRemovedImages}
              length={100}
            />
          </div>
        </Col>
        <Col span={19}>
          <div
            style={{
              padding: "15px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              backgroundColor: "#FFFFFF",
            }}
          >
            <Row gutter={24}>
              <Form
                onFinish={onFinish}
                layout="vertical"
                form={form}
                initialValues={{ layout: "vertical" }}
              >
                <Row gutter={24} style={{ padding: 20 }}>
                  <Col span={8}>
                    <Form.Item name="container_id">
                      <MaterialLikeInput
                        label="Container ID"
                        value={form.getFieldValue("container_id")}
                        onChange={(e) => form.setFieldValue("container_id", e.target.value)}
                        readOnly
                      />
                      {/* <Input readOnly style={{ background: '#EEEEEE' }} /> */}
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item name="c_booking_number" rules={[{ required: true, message: "Please enter booking number!" }]}>
                      <div>
                        <MaterialLikeInput
                          label="Booking Number"
                          value={bookingInput}
                          loading={bookingLoading}
                          onChange={(e) => {
                            const value = e.target.value;
                            setBookingInput(value); // Update local input
                            form.setFieldValue("c_booking_number", value); // Update form
                            setBookingMessage(''); // Clear old messages
                            checkBookingExistsDebounced(value, originalBookingNumber); // Debounced API call
                          }}
                        />
                        {bookingMessage && (
                          <span className={`text-[11px] ${bookingExists ? 'text-red-600' : 'text-green-600'} mt-1`}>
                            {bookingMessage}
                          </span>
                        )}
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item name="c_container_number">
                      <MaterialLikeInput
                        label="Container Number"
                        value={form.getFieldValue("c_container_number")}
                        onChange={(e) => form.setFieldValue("c_container_number", e.target.value)}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item name="shipping_line_id" rules={[{ required: true, message: "Please select a shipping line!" }]}>

                      <MaterialLikeSelect
                        label="Shipping Line"
                        required
                        value={form.getFieldValue("shipping_line_id")}
                        onChange={(value) => form.setFieldValue("shipping_line_id", value)}
                        options={shippingLine?.map((ship) => ({
                          key: ship.id,
                          value: ship.id,
                          label: ship.name,
                        }))}
                      />

                      {/* <Select placeholder="Shipping Line" showSearch optionFilterProp="children">
                        {shippingLine.map((ship) => (
                          <Select.Option key={ship.id} value={ship.id}>
                            {ship.name}
                          </Select.Option>
                        ))}
                      </Select> */}
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      name="destination"
                      rules={[
                        {
                          required: true,
                          message: "Please select a destination!",
                        },
                      ]}
                    >
                      <MaterialLikeSelect
                        label="Destination"
                        required
                        value={form.getFieldValue("destination")}
                        onChange={(value) => form.setFieldValue("destination", value)}
                        options={destinations?.map((dest) => ({
                          key: dest.id,
                          value: dest.name,
                          label: dest.name,
                        }))}
                      />
                      {/* <Select
                        placeholder="Destination"
                        showSearch
                        optionFilterProp="children"
                      >
                        {destinations.map((destination) => (
                          <Select.Option
                            key={destination.id}
                            value={destination.name}
                          >
                            {destination.name}
                          </Select.Option>
                        ))}
                      </Select> */}
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item name="container_size" rules={[{ required: true, message: "Please select a container size!" }]}>
                      <MaterialLikeSelect
                        label="Container Size"
                        required
                        value={form.getFieldValue("container_size")}
                        onChange={(value) => form.setFieldValue("container_size", value)}
                        options={containerSize?.map((size) => ({
                          key: size.id,
                          value: size.name,
                          label: size.name,
                        }))}
                      />
                      {/* <Select placeholder="Container Size">
                        {containerSize.map((size) => (
                          <Select.Option key={size.id} value={size.name}>
                            {size.name}
                          </Select.Option>
                        ))}
                      </Select> */}
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24} style={{ padding: 20 }}>
                  <Col span={12}>
                    <Form.Item name="pull_out_date">
                      <MaterialLikeDatePicker
                        label="Pull Out Date"
                        required
                        value={form.getFieldValue("pull_out_date")}
                        onChange={(date) => form.setFieldValue("pull_out_date", date)}
                      />
                      {/* <DatePicker placeholder="DD-MM-YYYY" style={{ width: "100%" }} /> */}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="gate_in_date">
                      <MaterialLikeDatePicker
                        label="Gate In Date"
                        required
                        value={form.getFieldValue("gate_in_date")}
                        onChange={(date) => form.setFieldValue("gate_in_date", date)}
                      />
                      {/* <DatePicker placeholder="DD-MM-YYYY" style={{ width: "100%" }} /> */}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="customised_date">
                      <MaterialLikeDatePicker
                        label="Customised Date"
                        required
                        value={form.getFieldValue("customised_date")}
                        onChange={(date) => form.setFieldValue("customised_date", date)}
                      />
                      {/* <DatePicker placeholder="DD-MM-YYYY" style={{ width: "100%" }} /> */}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="eta_date">
                      <MaterialLikeDatePicker
                        label="ETA Date"
                        required
                        value={form.getFieldValue("eta_date")}
                        onChange={(date) => form.setFieldValue("eta_date", date)}
                      />
                      {/* <DatePicker placeholder="DD-MM-YYYY" style={{ width: "100%" }} /> */}
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      style={{ textAlign: "right", marginTop: 30 }}
                      name="is_customer_own_loading"
                    >
                      <Checkbox
                        checked={customerOwnLoading}
                        onChange={(e) =>
                          setCustomerOwnLoading(e.target.checked)
                        }
                      >
                        Customer Own Loading
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Add New Car" name="new_car">
                      <VehicleDropDown CarOptions={newCarOptions} fetchCarOptions={fetchCarOptions} setCarOptions={setNewCarOptions} handleSelect={handleSelect} loading={carLoading} />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Row>
            <div
              style={{
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                backgroundColor: "#FFFFFF",
                margin: 5,
                marginTop: 10,
              }}
            >
              <Table
                columns={columns}
                pagination={false}
                scroll={{ x: "max-content" }}
                dataSource={vehicles}
                style={{ marginTop: "5px" }}
              />
            </div>
            {vehicles.some(vehicle => vehicle.engine_type === "EV" || vehicle.engine_type === "HYBRID") && <Row>
              <Col span={24} style={{ textAlign: "right", padding: 20 }}>
                <Checkbox checked={DG} onChange={handleCheckboxChange} style={{ fontWeight: "bolder", transform: "scale(1.2)", }}>IS DG</Checkbox>
              </Col>
            </Row>}

            <Row gutter={24} style={{ padding: 10 }}>
              {
                (loadingPlan.is_dg === 1 && (loadingPlan.imo_id === null) && vehicles.some(vehicle => vehicle.engine_type === "EV" || vehicle.engine_type === "HYBRID")) &&
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button type="primary" onClick={() => navigate(`/operations/loadings/imo/edit/${loadingPlan?.c_booking_number}`, { state: { isAdd: true } })}>Generate IMO</Button>
                </Col>
              }

              {
                (loadingPlan.is_dg === 1 && (loadingPlan.imo_id !== null) && vehicles.some(vehicle => vehicle.engine_type === "EV" || vehicle.engine_type === "HYBRID")) &&
                <Col span={24} style={{ textAlign: "right", marginTop: 8 }}>
                  <Button type="primary" onClick={() => window.open(`/operations/loadings/imo/view/${loadingPlan?.imo_id}`)}>View IMO</Button>
                </Col>
              }
            </Row>

            <Row
              gutter={24}
              style={{
                marginTop: 40,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >

              <Col span={6}>
                <SkeletonButton onClick={() => {
                  setType("Update - Save")
                  form.submit()
                }}
                  loading={loading}
                > Update</SkeletonButton>

                {/* <Button
                  type="primary"
                  style={{ width: "100%" }}
                  onClick={() => { setType("Update - Save"); form.submit() }}
                >
                  Update
                </Button> */}
              </Col>
              <Col span={6}>
                <SkeletonButton onClick={() => {
                  setType("Update - Load")
                  form.submit()
                }}
                  loading={loading}
                >  Move To Loaded</SkeletonButton>
                {/* <Button
                  type="primary"
                  style={{ width: "100%" }}
                  onClick={() => { setType("Update - Load"); form.submit() }}
                  loading={loading}
                >
                  Move To Loaded
                </Button> */}

              </Col>
            </Row>

            <div
              style={{
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                backgroundColor: "#FFFFFF",
                margin: 5,
                marginTop: 40,
              }}
            >
              <Row gutter={16}>
                <Col span={12}>
                  <h1 style={{ fontWeight: "bold" }}>
                    Freight Forwarder / Transporter
                  </h1>
                </Col>
              </Row>
              <Table
                columns={columns2}
                pagination={false}
                scroll={{ x: "max-content" }}
                dataSource={ledger}
                style={{ marginTop: "5px" }}
              />

              <div
                style={{ marginTop: 20 }}
                className="flex flex-col justify-center items-center"
              >
                <CiSquarePlus
                  style={{ cursor: "pointer", fontSize: "25px" }}
                  onClick={handleAddRow}
                />
              </div>
            </div>
            <Row
              gutter={24}
              style={{
                marginTop: 20,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Col span={6}>

                <SkeletonButton onClick={handleFreight} loading={freightLoad} >Save</SkeletonButton>
                {/* <Button
                  type="primary"
                  style={{ width: "100%" }}
                  onClick={handleFreight}
                  loading={freightLoad}
                >
                  Save
                </Button> */}
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default EditSavePlan;
